import * as React from 'react';
import { useWizard } from '../../../../../../design-system';
import { DetailsEvnexStep } from './DetailsEvnexStep';
import { DetailsOtherStep } from './DetailsOtherStep';

export const DetailsStep: React.FC = () => {
  const wizard = useWizard();
  const { state } = wizard as unknown as { state: { vendor: string } };

  switch (state.vendor) {
    case 'evnex':
      return <DetailsEvnexStep />;
    default:
      return <DetailsOtherStep />;
  }
};
